/* ============================================================
   CLOUT MERCH — QUICK VIEW
   Warstwa NAWIGACJI nad gridem. Fundamenty (AJAX /cart/add.js,
   fly-to-cart, size-bar z dragiem i rubber-bandem, slide-to-add)
   są tu przeniesione 1:1 z PDP, tylko oskoponowane per popup.

   Progressive enhancement:
   - brak <dialog>.showModal() lub brak JS  → karta nawiguje na PDP,
   - brak fetch                             → formularz robi natywny POST,
   - brak PointerEvent                      → zostają klik/klawiatura.

   History API: otwarcie = pushState na URL produktu (share = pełna
   strona), zamknięcie = history.back(), popstate zamyka/otwiera.
   ============================================================ */
(function () {
  'use strict';

  var dialogs = [].slice.call(document.querySelectorAll('[data-qv]'));
  if (!dialogs.length) return;
  if (typeof HTMLDialogElement === 'undefined') return;
  if (typeof HTMLDialogElement.prototype.showModal !== 'function') return;

  var docEl = document.documentElement;
  var MOBILE = '(max-width: 780px)';
  var thisScript = document.currentScript || document.querySelector('script[data-added]');
  var ADDED = (thisScript && thisScript.getAttribute('data-added')) || 'Added to cart';

  var toast = document.querySelector('[data-cart-toast]');
  var toastText = document.querySelector('[data-cart-toast-text]');
  var toastClose = document.querySelector('[data-cart-toast-close]');
  var cartLink = document.querySelector('.site-header__cart');
  var countEl = document.querySelector('[data-cart-count]');

  var current = null; /* otwarty popup */
  var busy = false; /* jedno POST na raz */
  /* WŁAŚCICIEL flagi busy. `busy` jest globalne (jedno POST na cały grid), ale
     okno, w którym stoi podniesione, to POST + ewentualne round-tripy recovery
     + choreografia potwierdzenia + wyjazd panelu. W tym oknie user może otworzyć
     INNY popup — bez referencji do właściciela nie dałoby się dokończyć jego
     choreografii ani opuścić flagi (patrz prepare/flushAck). */
  var busyCtx = null;
  var toastTimer = null;
  var selfBack = false; /* nasz własny history.back() z dismiss() */

  function isMobile() { return window.matchMedia(MOBILE).matches; }
  /* Jedna MediaQueryList na dokument: `.matches` jest i tak ŻYWE (łapie
     przełączenie preferencji w trakcie gestu), a matchMedia() wołane
     z pointermove — tak sprawdza się preferencję przy odpowiedzi panelu
     na drag size-bara — nie może produkować obiektu na każdą próbkę. */
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  function isReduced() { return REDUCE.matches; }

  /* ---------- scroll lock (bez skoku layoutu) ---------- */
  function lockScroll() {
    var gap = window.innerWidth - docEl.clientWidth;
    if (gap > 0) docEl.style.setProperty('--qv-sb', gap + 'px');
    docEl.classList.add('qv-open');
  }
  function unlockScroll() {
    docEl.classList.remove('qv-open');
    docEl.style.removeProperty('--qv-sb');
  }

  /* ---------- kontekst popupu ---------- */
  function ctxOf(dlg) {
    if (dlg.qvCtx) return dlg.qvCtx;
    var c = {
      dlg: dlg,
      panel: dlg.querySelector('.qv__panel'),
      form: dlg.querySelector('.qv__form'),
      shot: dlg.querySelector('.qv__shot'),
      bar: dlg.querySelector('.size-bar'),
      foot: dlg.querySelector('[data-qv-foot]'),
      slide: dlg.querySelector('[data-slide-buy]'),
      err: dlg.querySelector('[data-qv-error]'),
      lb: dlg.querySelector('[data-qv-lightbox]'),
      views: dlg.querySelector('[data-qv-views]'),
      viewBuy: dlg.querySelector('[data-qv-view-buy]'),
      viewInfo: dlg.querySelector('[data-qv-view-info]'),
      infoOpen: dlg.querySelector('[data-qv-info-open]'),
      infoClose: dlg.querySelector('[data-qv-info-close]')
    };
    c.thumb = c.slide ? c.slide.querySelector('.slide-buy__thumb') : null;
    c.inputs = c.bar ? [].slice.call(c.bar.querySelectorAll('input[name="id"]')) : [];
    /* CTA jest DWA (widok BUY i widok DETAILS) — oba submitują ten sam
       formularz, więc oba muszą umieć pokazać potwierdzenie */
    c.ctas = [].slice.call(dlg.querySelectorAll('[data-qv-cta]'));
    c.ackT = null;    /* choreografia potwierdzenia → dismiss */
    c.ackBarT = null; /* uścisk kciuka size-bara */
    /* osie wspólnego `translate` panelu — patrz setPanelTranslate */
    c.tx = 0; /* odpowiedź okna na gest size-bara (lean / kick) */
    c.ty = 0; /* swipe-down po uchwycie sheeta */
    dlg.qvCtx = c;
    return c;
  }

  /* ---------- panel: JEDEN writer na `translate` ----------
     Na panelu piszą DWIE niezależne mechaniki: swipe-down uchwytu (oś Y)
     i odpowiedź okna na drag size-bara (oś X, patrz initSizeDrag). `translate`
     to JEDNA właściwość — kto pisze ją stringiem "0 12px", ten ścina drugą oś.
     Stąd jeden writer i dwa pola stanu na kontekście popupu.

     Dlaczego w ogóle `translate`, a nie `transform`: transform panelu należy
     do keyframes wejścia/wyjścia (qv-pop / qv-sheet / qv-out), a qv-sheet leci
     z `both`, więc na mobile trzyma transform TAK DŁUGO, JAK POPUP JEST OTWARTY
     — animacja bije inline style w kaskadzie. Dokładnie dlatego swipe uchwytu
     siedzi na `translate` i tam dosiadamy się z drugą osią.

     W spoczynku (obie osie zerowe) właściwość jest ZDEJMOWANA — panel nie
     zostaje z martwym stylem po geście. */
  function setPanelTranslate(c) {
    if (!c.panel) return;
    if (!c.tx && !c.ty) { c.panel.style.removeProperty('translate'); return; }
    c.panel.style.translate = c.tx.toFixed(2) + 'px ' + c.ty.toFixed(2) + 'px';
  }
  function panelX(c, x) { c.tx = x; setPanelTranslate(c); }
  function panelY(c, y) { c.ty = y; setPanelTranslate(c); }

  /* twarde wyzerowanie obu osi — otwarcie i zamknięcie popupu */
  function resetPanelTranslate(c) {
    if (c.leanOff) c.leanOff();
    c.tx = 0;
    c.ty = 0;
    if (c.panel) c.panel.style.removeProperty('translate');
  }

  /* ---------- widoki BUY <-> DETAILS ---------- */
  function replayViewAnim(el) {
    el.classList.remove('qv__view-enter');
    void el.offsetWidth; /* restart animacji */
    el.classList.add('qv__view-enter');
  }

  function setInfoView(c, on) {
    if (!c.viewInfo || !c.viewBuy) return;
    var showEl = on ? c.viewInfo : c.viewBuy;
    var hideEl = on ? c.viewBuy : c.viewInfo;
    if (!showEl.hidden) return; /* juz tam jestesmy / animacja w toku */

    var wrap = c.views;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!wrap || reduce) {
      hideEl.hidden = true;
      showEl.hidden = false;
    } else {
      /* crossfade + tween wysokosci: stary widok gasnie jako absolutny
         overlay, nowy wchodzi w flow, a wrapper plynnie dojezdza do jego
         wysokosci — zero przeskoku layoutu */
      var h0 = wrap.offsetHeight;
      hideEl.classList.add('qv__view--out');
      showEl.hidden = false;
      replayViewAnim(showEl);
      wrap.classList.add('qv__views--anim');
      wrap.style.height = h0 + 'px';
      void wrap.offsetHeight; /* start tweenu od h0 */
      wrap.style.height = showEl.offsetHeight + 'px';
      clearTimeout(wrap.qvViewT);
      wrap.qvViewT = setTimeout(function () {
        hideEl.classList.remove('qv__view--out');
        hideEl.hidden = true;
        showEl.classList.remove('qv__view-enter');
        wrap.classList.remove('qv__views--anim');
        wrap.style.removeProperty('height');
      }, 340);
    }

    if (c.infoOpen) c.infoOpen.setAttribute('aria-expanded', on ? 'true' : 'false');
    /* fokus: do detali — na BACK; z powrotem — na toggle */
    if (on && c.infoClose) c.infoClose.focus();
    if (!on && c.infoOpen) c.infoOpen.focus();
  }

  /* ---------- slide to add: reset ---------- */
  function resetSlide(c) {
    if (!c.slide) return;
    c.slide.classList.remove('slide-buy--done', 'slide-buy--dragging');
    c.slide.style.setProperty('--slide-p', '0');
    if (c.thumb) c.thumb.style.transform = '';
  }

  /* ---------- potwierdzenie na CTA / kciuku: reset ----------
     Popupy są REUŻYWANE (jeden <dialog> per karta żyje w DOM na stałe), więc
     stan potwierdzenia musi dać się zdjąć co do znaku — inaczej user zobaczy
     "ADDED" na czerwono przy następnym otwarciu tej samej karty. */
  function resetAck(c) {
    for (var i = 0; i < c.ctas.length; i++) {
      var btn = c.ctas[i];
      btn.classList.remove('cta--added');
      var lab = btn.querySelector('[data-qv-cta-label]');
      /* oryginalny label zapamiętany przy PIERWSZEJ podmianie (patrz ack) —
         nigdy nie trzymamy tekstu w JS, bo to treść z locale */
      if (lab && lab.qvLabel0 != null) lab.textContent = lab.qvLabel0;
    }
    if (c.ackBarT) { clearTimeout(c.ackBarT); c.ackBarT = null; }
    if (c.bar) c.bar.classList.remove('size-bar--ack');
  }

  /* ---------- stan popupu przed pokazaniem ---------- */
  function armSlide(c, on) {
    if (!c.foot) return;
    c.foot.classList.toggle('qv__foot--active', !!on);
    if (c.thumb) c.thumb.disabled = !on;
  }

  function prepare(c) {
    if (c.err) { c.err.hidden = true; c.err.textContent = ''; }
    /* re-open w oknie choreografii — patrz komentarz przy flushAck. Flushujemy
       też popup, który podniósł busy, gdy to INNY dialog: jego ackT zamknąłby
       potem cudze okno, a globalny busy przeżyłby otwarcie tego popupu i zjadł
       pierwszy submit bez potwierdzenia. */
    flushAck(c);
    if (busyCtx && busyCtx !== c) flushAck(busyCtx);
    resetAck(c);
    resetSlide(c);
    resetPanelTranslate(c);
    c.ghostTried = false; /* nowe otwarcie = nowa szansa na ghost-recovery */

    /* popup zawsze otwiera się na widoku zakupowym (bez ruszania fokusa);
       sprzatamy tez ewentualna przerwana animacje przelaczania */
    if (c.viewInfo && c.viewBuy) {
      c.viewBuy.hidden = false;
      c.viewBuy.classList.remove('qv__view--out', 'qv__view-enter');
      c.viewInfo.hidden = true;
      c.viewInfo.classList.remove('qv__view--out', 'qv__view-enter');
      if (c.views) {
        clearTimeout(c.views.qvViewT);
        c.views.classList.remove('qv__views--anim');
        c.views.style.removeProperty('height');
      }
      if (c.infoOpen) c.infoOpen.setAttribute('aria-expanded', 'false');
    }

    if (!c.inputs.length) {
      /* produkt bez rozmiarów — kupno jest o jeden gest krótsze */
      armSlide(c, true);
      return;
    }

    if (isMobile()) {
      /* Bez pre-zaznaczenia: wybór rozmiaru ma być świadomy (hint w legendzie).
         Radiogroup bez wyboru jest poprawny; required pilnuje submitu. */
      for (var i = 0; i < c.inputs.length; i++) c.inputs[i].checked = false;
      armSlide(c, false);
    } else {
      /* Desktop: pierwszy dostępny pre-zaznaczony (Liquid już to zrobił —
         przywracamy po ewentualnym zamknięciu w trybie mobilnym). */
      var any = false;
      var first = null;
      for (var j = 0; j < c.inputs.length; j++) {
        if (c.inputs[j].checked) any = true;
        if (!first && !c.inputs[j].disabled) first = c.inputs[j];
      }
      if (!any && first) first.checked = true;
      armSlide(c, true);
    }
  }

  /* ---------- otwieranie / zamykanie ----------
     Wejście jest animowane (qv-pop / qv-sheet), więc wyjście też musi być:
     hide() dokłada .qv--closing, a dialog.close() leci dopiero na animationend
     panelu. Bez animacji (reduced motion, brak panelu) zamyka się od razu. */
  var CLOSE_FALLBACK = 360; /* > najdłuższej animacji wyjścia (.26s sheet) */

  /* kolejka „po zamknięciu” — trzymana na elemencie, żeby callback (lot
     packshotu + toast) nie przepadł, gdy user domknie popup Esc-em jeszcze
     w trakcie POST-a: dodanie do koszyka MUSI dostać potwierdzenie */
  function onClosed(dlg, cb) {
    if (!cb) return;
    if (!dlg.qvDone) dlg.qvDone = [];
    dlg.qvDone.push(cb);
  }

  /* twarde zamknięcie, bez animacji — przy przełączaniu popupów (dwa dialogi
     w top-layerze naraz czytałyby się jak glitch) i jako meta animacji */
  function closeNow(dlg, done) {
    var c = ctxOf(dlg);
    onClosed(dlg, done);
    if (c.lb && c.lb.open) c.lb.close();
    if (dlg.qvCloseT) { clearTimeout(dlg.qvCloseT); dlg.qvCloseT = null; }
    dlg.classList.remove('qv--closing');
    if (dlg.open) dlg.close(); /* dalej robi handler 'close' */
    var q = dlg.qvDone;
    dlg.qvDone = null;
    if (q) for (var k = 0; k < q.length; k++) q[k]();
  }

  function hide(dlg, done) {
    var c = ctxOf(dlg);
    if (!dlg.open) { closeNow(dlg, done); return; }
    if (dlg.qvCloseT) { onClosed(dlg, done); return; } /* wyjście już trwa */
    if (isReduced() || !c.panel) { closeNow(dlg, done); return; }
    if (c.lb && c.lb.open) c.lb.close();
    onClosed(dlg, done);

    dlg.classList.add('qv--closing');
    var onEnd = function (e) {
      if (e.target !== c.panel) return;
      c.panel.removeEventListener('animationend', onEnd);
      closeNow(dlg);
    };
    c.panel.addEventListener('animationend', onEnd);
    /* gdyby animacji nie było (nadpisany CSS, brak wsparcia) popup nie może
       zostać otwarty na zawsze — timer domyka go bezwarunkowo */
    dlg.qvCloseT = setTimeout(function () {
      c.panel.removeEventListener('animationend', onEnd);
      closeNow(dlg);
    }, CLOSE_FALLBACK);
  }

  /* ---------- fade-in po załadowaniu ----------
     Niezaładowany <img> renderuje ALT (nazwa produktu miga przed zdjęciem).
     Obraz siedzi w opacity:0 (.img-fade w CSS) i dostaje .is-loaded dopiero,
     gdy plik realnie jest — error też odsłania (alt to wtedy jedyna treść). */
  function revealWhenLoaded(img) {
    if (!img || img.qvReveal) return;
    img.qvReveal = true;
    img.classList.add('img-fade');
    var done = function () { img.classList.add('is-loaded'); };
    if (img.complete && img.naturalWidth > 0) { done(); return; }
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  /* ---------- rozgrzewanie lightboxa ----------
     Obrazy lightboxa mają loading="lazy" w zamkniętym <dialog> — nie pobierają
     się przed otwarciem popupu (celowo: 13 popupów nie może kosztować
     transferu). Ale między otwarciem POPUPU a klikiem ZOOM jest zwykle kilka
     sekund — grzejemy w tym oknie: pierwsze zdjęcie od razu, resztę na idle.
     Przy Save-Data grzejemy tylko pierwsze. */
  function warmLightbox(c) {
    if (!c.lb || c.lbWarmed) return;
    c.lbWarmed = true;
    var imgs = [].slice.call(c.lb.querySelectorAll('[data-lb-img]'));
    if (!imgs.length) return;
    imgs[0].loading = 'eager';
    if (imgs.length < 2) return;
    var conn = navigator.connection;
    if (conn && conn.saveData) return;
    var warmRest = function () {
      for (var k = 1; k < imgs.length; k++) imgs[k].loading = 'eager';
    };
    if (window.requestIdleCallback) requestIdleCallback(warmRest, { timeout: 2000 });
    else setTimeout(warmRest, 600);
  }

  function open(dlg, url, viaHistory) {
    if (dlg.qvCloseT) closeNow(dlg); /* re-tap w trakcie wyjścia = otwórz od nowa */
    else if (current === dlg) return;
    if (current && current !== dlg) closeNow(current);
    var c = ctxOf(dlg);
    prepare(c);
    revealWhenLoaded(c.shot);
    lockScroll();
    current = dlg;
    dlg.showModal();
    warmLightbox(c);
    if (!viaHistory && url) {
      try { history.pushState({ cloutQv: dlg.id }, '', url); } catch (e) { /* np. cross-origin */ }
    }
  }

  /* Zamknięcie inicjowane przez usera: panel wyjeżdża, a wpis historii zwijamy
     od razu (traversal i tak jest asynchroniczny). `done` odpala się PO close(),
     żeby fly-to-cart i toast miały wolny ekran — dialog w top-layerze
     zasłoniłby lecący klon packshotu. */
  function dismiss(dlg, done) {
    /* drugi gest/Esc w trakcie wyjścia: historia jest już zwinięta, więc tylko
       dowieszamy callback — podwójny back() wyrzuciłby usera z kolekcji */
    if (dlg.qvCloseT) { onClosed(dlg, done); return; }
    var owned = !!(history.state && history.state.cloutQv === dlg.id);
    hide(dlg, done);
    if (owned) {
      /* traversal jest ASYNCHRONICZNY: gdyby user w tym okienku otworzył inny
         item (pushState), popstate przyszedłby ze stanem TEGO popupu i handler
         niżej otworzyłby go z powrotem — user zobaczyłby item, którego nie
         kliknął. Flaga mówi: ten popstate to nasze własne sprzątanie. */
      selfBack = true;
      history.back();
    }
  }

  window.addEventListener('popstate', function () {
    if (selfBack) { selfBack = false; return; }
    var st = history.state;
    var id = st && st.cloutQv;
    var target = id ? document.getElementById(id) : null;
    /* wejście innego popupu = przełączenie (twardo), samo cofnięcie = wyjazd */
    if (current && current !== target) {
      if (target) closeNow(current); else hide(current);
    }
    if (target && !target.open) open(target, null, true);
  });

  /* ---------- fly to cart (klon packshotu z popupu leci do headera) ----------
     Kadr startowy (`from`) MUSI być zmierzony przed zamknięciem popupu —
     zamknięty <dialog> to display:none, czyli rect 0×0. Zwraca false, gdy
     lotu nie ma (reduced motion / brak kadru) — wtedy licznik pulsuje sam. */
  function fly(img, from) {
    if (!img || !from || !cartLink) return false;
    if (isReduced() || !img.complete) return false;
    var to = cartLink.getBoundingClientRect();
    if (from.width === 0 || to.width === 0) return false;
    var ghost = img.cloneNode();
    ghost.removeAttribute('srcset');
    ghost.removeAttribute('sizes');
    ghost.removeAttribute('loading');
    ghost.className = 'fly-ghost';
    ghost.style.top = from.top + 'px';
    ghost.style.left = from.left + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    document.body.appendChild(ghost);
    /* header wyscrollowany za kadr → lądowanie klampujemy do górnej krawędzi,
       żeby lot zawsze KOŃCZYŁ się w widocznym miejscu */
    var toY = to.top < 8 ? 8 : to.top;
    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = toY + to.height / 2 - (from.top + from.height / 2);
    var anim = ghost.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.55 + 'px, ' + (dy - 70) + 'px) scale(.38)', opacity: 0.9, offset: 0.55 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.05)', opacity: 0.25 }
      ],
      { duration: 720, easing: 'cubic-bezier(.3, .7, .35, 1)' }
    );
    anim.onfinish = function () {
      ghost.remove();
      bumpCount();
    };
    return true;
  }

  function bumpCount() {
    if (!countEl) return;
    countEl.classList.remove('cart-bump');
    void countEl.offsetWidth; /* restart animacji */
    countEl.classList.add('cart-bump');
  }

  /* ---------- toast ----------
     Toast nie jest samym potwierdzeniem — ma w środku link VIEW CART, czyli
     interaktywną treść na timerze. Stąd 8s bazowo i pauza na hover/fokusie
     (WCAG 2.2.1 / 1.4.13): dojście Tabem do linku przez resztę gridu musi być
     możliwe, a kursor w drodze do linku nie może go zgasić. */
  var TOAST_MS = 8000;

  function armToastTimer() {
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  function showToast() {
    if (!toast) return;
    /* pusty start: dopisanie tekstu MUSI być realną zmianą treści regionu,
       także gdy user dodaje drugą rzecz przy jeszcze widocznym toaście */
    if (toastText) toastText.textContent = '';
    toast.hidden = false;
    /* wymuszony reflow, NIE requestAnimationFrame: rAF jest wstrzymywany
       w tle karty, a wtedy toast zostałby z hidden=false i opacity 0 —
       niewidoczny, ale łapiący kliknięcia przy dolnej krawędzi. */
    void toast.offsetWidth;
    toast.classList.add('toast--in');
    /* tekst dopisujemy DOPIERO po odsłonięciu regionu: mutacja role="status"
       zrobiona jeszcze pod display:none (toast[hidden]) trafia w węzeł, którego
       nie ma w drzewie dostępności, i czytniki jej nie ogłaszają */
    setTimeout(function () {
      if (toastText && !toast.hidden) toastText.textContent = ADDED;
    }, 60);
    armToastTimer();
  }

  function hideToast() {
    if (!toast) return;
    clearTimeout(toastTimer);
    toastTimer = null;
    toast.classList.remove('toast--in');
    /* czyścimy tekst, żeby następne dodanie było dla czytnika realną zmianą
       treści regionu, a nie przepisaniem tej samej wartości */
    var clear = function () {
      if (!toast.classList.contains('toast--in')) {
        toast.hidden = true;
        if (toastText) toastText.textContent = '';
      }
    };
    if (isReduced()) { clear(); return; }
    setTimeout(clear, 240);
  }

  if (toastClose) toastClose.addEventListener('click', hideToast);

  if (toast) {
    var pauseToast = function () { clearTimeout(toastTimer); toastTimer = null; };
    var resumeToast = function () {
      if (toast.classList.contains('toast--in')) armToastTimer();
    };
    toast.addEventListener('pointerenter', pauseToast);
    toast.addEventListener('pointerleave', resumeToast);
    toast.addEventListener('focusin', pauseToast);
    toast.addEventListener('focusout', function (e) {
      if (e.relatedTarget && toast.contains(e.relatedTarget)) return;
      resumeToast();
    });
  }

  /* ---------- choreografia potwierdzenia (przed zamknięciem) ----------
     Dotąd sukces zamykał popup NATYCHMIAST: potwierdzenie żyło dopiero
     za oknem (lot packshotu + toast), a miejsce, w które user właśnie
     kliknął, nie odpowiadało niczym. Trzy gesty, jeden język — ten sam,
     którym mówi size-bar: ink wipe (tusz), uścisk (skala chwytu), kick
     (impuls sprężyny). Zero nowych idiomów, zero nowych easingów.

     Amplitudy i czasy dobrane tak, żeby całość zmieściła się PRZED
     wyjazdem panelu i nie opóźniła zakupu bardziej niż jedno mrugnięcie. */
  var ACK_MS = 450;       /* całość: wipe (.26s) + uścisk + kick zdążą wybrzmieć */
  var ACK_BAR_MS = 170;   /* kciuk w górę; powrót dowozi transition scale .22s */
  var ACK_KICK_VX = 4.5;  /* impuls X w stronę koszyka: szczyt ~6px < KICK_MAX 12 */
  /* oś Y ma WŁASNE, mocniej tłumione stałe (SHEET_D .55 — niesie dociągnięcie
     sheeta, nie lean), więc ten sam impuls daje tam mniej drogi: -3.5 to
     szczyt ~3px w górę. Panel ma drgnąć w stronę koszyka, nie odlecieć. */
  var ACK_KICK_VY = -3.5;

  /* Zwraca false, gdy nie ma czego pokazać (reduced motion, produkt bez
     rozmiarów na mobile z ukrytym CTA) — wtedy dismiss leci jak dotąd,
     bez pustego oczekiwania. */
  function ack(c) {
    /* preferencja czytana NA ŻYWO, jak wszędzie w tym pliku */
    if (isReduced()) return false;
    /* Martwe okno — user zamknął popup, zanim /cart/add.js odpowiedział (albo
       w trakcie ścieżki ghost-recovery). Nie ma czego pokazać: panel jest
       w display:none albo właśnie wyjeżdża. Bez tego bailoutu added() czekałoby
       ACK_MS na choreografię, której nikt nie widzi, a potwierdzenie (licznik
       + toast) spóźniłoby się o 450 ms i straciło lot packshotu — kadr `from`
       z zamkniętego <dialog> to 0×0, więc fly() i tak by odpadł.
       Kontrakt z onClosed: dodanie do koszyka MUSI dostać potwierdzenie —
       na zamkniętym oknie znaczy to NATYCHMIAST. */
    if (!c.dlg.open || c.dlg.qvCloseT) return false;
    var did = false;

    /* 1. CTA — ink wipe zalany na stałe + twarda podmiana labelu.
       Na mobile CTA jest display:none (jedynym CTA jest slide-to-buy,
       a tam potwierdzeniem jest sam doślizg suwaka), a CTA z widoku
       DETAILS jest ukryte razem z widokiem — offsetParent === null
       obsługuje oba przypadki jednym warunkiem. */
    for (var i = 0; i < c.ctas.length; i++) {
      var btn = c.ctas[i];
      if (!btn.offsetParent) continue;
      var lab = btn.querySelector('[data-qv-cta-label]');
      var added = btn.getAttribute('data-added');
      if (lab && added) {
        if (lab.qvLabel0 == null) lab.qvLabel0 = lab.textContent;
        lab.textContent = added; /* hard cut — bez fade, idiom marki */
      }
      btn.classList.add('cta--added');
      did = true;
    }

    /* 2. Size-bar — kciuk ściska się tak samo jak przy chwycie ("handshake"
       wybranego rozmiaru). Także na mobile: tam CTA nie ma, więc to jedyny
       feedback wewnątrz panelu obok samego doślizgu. */
    if (c.bar && c.inputs.length) {
      c.bar.classList.add('size-bar--ack');
      clearTimeout(c.ackBarT);
      c.ackBarT = setTimeout(function () {
        c.ackBarT = null;
        c.bar.classList.remove('size-bar--ack');
      }, ACK_BAR_MS);
      did = true;
    }

    /* 3. Panel — jednorazowy kick w stronę koszyka (góra-prawo) TYM SAMYM
       integratorem, który obsługuje lean/kick size-bara. Integrator żyje
       w domknięciu initSizeDrag, więc przy <2 dostępnych rozmiarach i bez
       PointerEvent go po prostu nie ma — reszta sekwencji działa dalej. */
    if (c.leanKick && c.leanKick(ACK_KICK_VX, ACK_KICK_VY)) did = true;

    return did;
  }

  /* Popup otwierany ponownie w oknie choreografii (user zdążył zamknąć
     i kliknąć tę samą kartę): timer musi zniknąć, bo zamknąłby świeżo
     otwarty panel. Potwierdzenie NIE przepada — dostaje skróconą ścieżkę
     (bez lotu: nie ma z czego mierzyć kadru na zamkniętym oknie). */
  function flushAck(c) {
    if (!c || !c.ackT) return;
    clearTimeout(c.ackT);
    c.ackT = null;
    clearBusy();
    bumpCount();
    showToast();
  }

  /* Flaga schodzi ZAWSZE razem z właścicielem — inaczej busyCtx zostaje
     wskaźnikiem na kontekst, który dawno skończył, i prepare() flushowałby
     martwą choreografię. */
  function clearBusy() {
    busy = false;
    busyCtx = null;
  }

  /* ---------- add to cart ---------- */

  /* Sukces: choreografia → dismiss → lot → toast. Licznik doczytujemy
     równolegle, bo nie bierze udziału w sekwencji. */
  function added(c) {
    var finish = function () {
      c.ackT = null;
      /* Desktop i mobile tak samo: popup się zamyka, user wraca do gridu
         i widzi lot packshotu + toast + podbity licznik. */
      var shot = c.shot;
      /* lot i toast startują PO domknięciu popupu (dialog w top-layerze
         zasłonił by klona), więc kadr `from` mierzymy jeszcze przy otwartym */
      var from = shot ? shot.getBoundingClientRect() : null;
      dismiss(c.dlg, function () {
        /* busy zwalniane DOPIERO tutaj: przez całą choreografię formularz
           jest zamknięty na drugie POST (CTA ma pointer-events:none, ale
           Enter na sfokusowanym przycisku i suwak zostają) */
        clearBusy();
        if (!fly(shot, from)) bumpCount();
        showToast();
      });
    };

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (countEl) countEl.textContent = '[' + cart.item_count + ']';
      })
      .catch(function () { /* licznik to ozdoba potwierdzenia, nie ono samo */ });

    if (!ack(c)) { finish(); return; }
    c.ackT = setTimeout(finish, ACK_MS);
  }

  /* Błąd (np. stan wyczerpany między renderem a klikiem) — popup
     zostaje otwarty z komunikatem, suwak wraca na start. */
  function failed(c, err) {
    clearBusy();
    if (c.err) { c.err.textContent = err.message; c.err.hidden = false; }
    resetSlide(c);
    resetAck(c);
  }

  function postAdd(c) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(c.form)
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (j) {
          throw new Error(j.description || j.message || res.statusText);
        });
      }
      return res.json();
    });
  }

  /* ---------- "ghost cart" ----------
     Znany bug platformy: /cart/add.js odpowiada 422 "The product ... is
     already sold out." na WARIANT, który jest dostępny — cookie wskazuje
     skorumpowany koszyk (typowo po próbach dodania wyprzedanego wariantu;
     w incognito, czyli na świeżym cookie, ten sam add przechodzi).

     Sprzątamy tylko wtedy, gdy sprzątanie NIC NIE KOSZTUJE: koszyk jest
     pusty, więc /cart/clear.js nie może zjeść niczyjego zakupu. Retry leci
     DOKŁADNIE RAZ (flaga argumentowa, nie stan modułu — żadnej pętli), a
     jego porażka wraca na normalną ścieżkę błędu z ORYGINALNYM komunikatem
     ze Shopify: user nie ma się dowiadywać o naszym sprzątaniu. */
  var GHOST = /already sold out/i;

  function recover(c, err) {
    /* raz na sesję popupu: ten sam komunikat dla NAPRAWDĘ wyprzedanego
       wariantu nie może przy każdym kliknięciu mielić trzech round-tripów
       i POST-a na /cart/clear.js */
    if (c.ghostTried) { failed(c, err); return; }
    c.ghostTried = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.item_count !== 0) throw err; /* niepusty — nie ruszamy */
        return fetch('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (res) {
        if (!res.ok) throw err;
        send(c, true);
      })
      /* busy zostaje podniesione przez całą ścieżkę retry i schodzi dopiero
         tutaj albo w added() — jedno POST na raz, także w recovery */
      .catch(function () { failed(c, err); });
  }

  function send(c, retried) {
    postAdd(c)
      .then(function () { added(c); })
      .catch(function (err) {
        if (!retried && GHOST.test(err.message || '')) { recover(c, err); return; }
        failed(c, err);
      });
  }

  function addToCart(c) {
    if (busy) {
      /* Submit połknięty (trwa cudze/poprzednie POST). Bailout NIE MOŻE być
         niemy: initSlide dokleja `slide-buy--done` ZANIM zawoła requestSubmit,
         więc bez tego kciuk zostaje przyklejony na końcu toru z napisem
         "ADDING" aż do zamknięcia popupu — stan, którego nic nie dowozi.
         Cofamy suwak na start: gest nie został przyjęty i user to widzi. */
      resetSlide(c);
      return;
    }
    busy = true;
    busyCtx = c;
    if (c.err) { c.err.hidden = true; c.err.textContent = ''; }
    send(c, false);
  }

  /* ---------- size bar: drag / przytrzymanie (port z PDP, per popup) ----------
     1. setPointerCapture dopiero po progu 5px — inaczej capture przekierowuje
        cały click na track i psuje zwykłe klikanie w segmenty.
     2. Kciuk nie przejeżdża nad wyprzedanym rozmiarem: ruch clampowany do
        ciągłego zakresu dostępnych segmentów, z gumowym oporem na granicy
        (iOS rubber-band) + pulsem "odmowy" na blokującym segmencie. */
  function initSizeDrag(bar, c) {
    if (!window.PointerEvent) return;
    var track = bar.querySelector('.size-bar__track');
    var thumb = bar.querySelector('.size-bar__thumb');
    if (!track || !thumb) return;
    var labels = [].slice.call(track.querySelectorAll('label'));
    if (labels.length < 2) return;

    var enabled = labels.map(function (l) {
      var i = l.querySelector('input');
      return !!i && !i.disabled;
    });
    /* <2 dostepnych rozmiarow: nie ma czego przeciagac — kazdy grab
       teleportowalby kciuk na jedyny segment (zgloszony glitch przy
       'wszystko poza XL wyprzedane'). Zostaje czysty tap/klawiatura. */
    var enabledCount = 0;
    for (var ei = 0; ei < enabled.length; ei++) { if (enabled[ei]) enabledCount++; }
    if (enabledCount < 2) return;

    var armed = false;
    var dragging = false;
    var startX = 0;
    var run = null;
    var deniedSeg = null;
    var grabDX = 0; /* offset chwytu: punkt na kciuku, za ktory user go trzyma */

    /* ---------- odpowiedź OKNA na gest kciuka (tylko quick view) ----------
       Panel nie jest betonem: ma masę, która podąża za ręką. Dwa efekty,
       jedna sprężyna:
         LEAN — w trakcie przeciągania okno wychyla się w stronę ruchu,
                proporcjonalnie do przejazdu kciuka, MOCNO stłumione,
         KICK — dobicie kciuka do skrajnego DOSTĘPNEGO rozmiaru z impetem
                daje jednorazowy impuls w tę samą stronę.
       Efekt jest czysto fizyczny: żadna informacja od niego nie zależy
       (rozmiar niesie zaznaczenie i tekst), więc gaśnie pod reduced motion
       bez straty. Na PDP tego nie ma — tam nie ma okna, które mogłoby
       odpowiedzieć; `c` (kontekst popupu) jest tu jedynym włącznikiem. */
    var panel = c ? c.panel : null;
    var LEAN_MAX = 5;    /* px — ASYMPTOTA wychylenia, nie twardy clamp */
    var LEAN_SOFT = 90;  /* px przejazdu kciuka dające połowę asymptoty */
    var KICK_V = 5;      /* impuls prędkości: przy K/D poniżej szczyt ~7px */
    var KICK_MAX = 12;   /* px — bezpiecznik na sumę lean + kick */
    var FLICK = 650;     /* px/s PALCA — od tego progu dobicie ma "impet" */
    var WALL = 0.85;     /* squash — sam napór na ściankę wystarczy za impet */
    var SPRING_K = 0.16; /* sztywność */
    var SPRING_D = 0.74; /* tłumienie — jedno delikatne przeregulowanie */
    /* Oś Y dostaje WŁASNE stałe: niesie dociągnięcie sheeta po swipe-down,
       czyli drogę do 90px, a nie 5px leanu. Przeregulowanie osi X (~24%)
       wyrzuciłoby sheet 20px NAD krawędź. Te wartości naśladują CSS-owy
       powrót (translate .3s var(--ease-spring)): ~2% przeregulowania,
       wizualnie na miejscu po ~200ms. */
    var SHEET_K = 0.2;
    var SHEET_D = 0.55;
    var LEAN_CLS = 'qv__panel--lean';

    var sx = 0;    /* aktualne wychylenie panelu */
    var sv = 0;    /* prędkość sprężyny */
    var stgt = 0;  /* cel (samo LEAN — KICK wchodzi prędkością, nie celem) */
    var sraf = 0;
    /* oś Y: cel jest zawsze zerem (dociągnięcie sheeta), więc bez pola celu.
       `yOwn` mówi, czy integrator jest w tej chwili właścicielem osi — patrz
       catchY/dropY niżej; gdy nie jest, springStep NIE dotyka c.ty. */
    var sy = 0;
    var svy = 0;
    var yOwn = false;

    /* Jedna pętla rAF na popup, żywa tylko w trakcie gestu i powrotu
       (wzorzec lerper z micro.js). Sprężyna zamiast czystego lerpa, bo
       powrót ma być SPRĘŻYSTY — przeregulowanie robi tu prędkość, nie
       keyframe, więc ten sam integrator obsługuje LEAN i KICK. */
    function springStep() {
      sraf = 0;
      /* preferencja czytana NA ŻYWO także tutaj: powrót osi Y potrafi lecieć
         bez ani jednej próbki gestu (patrz catchY), więc kontrola w respond()
         by go nie złapała */
      if (isReduced()) { leanOff(); return; }
      sv = (sv + (stgt - sx) * SPRING_K) * SPRING_D;
      sx += sv;
      if (sx > KICK_MAX) { sx = KICK_MAX; sv = 0; }
      else if (sx < -KICK_MAX) { sx = -KICK_MAX; sv = 0; }
      var rest = !stgt && sx > -0.02 && sx < 0.02 && sv > -0.02 && sv < 0.02;
      if (rest) { sx = 0; sv = 0; }
      if (yOwn) {
        svy = (svy - sy * SHEET_K) * SHEET_D;
        sy += svy;
        if (sy > -0.02 && sy < 0.02 && svy > -0.02 && svy < 0.02) {
          sy = 0; svy = 0; yOwn = false; /* oś oddana z powrotem CSS-owi */
        } else {
          rest = false; /* X może już spać, sheet jeszcze jedzie */
        }
        c.ty = sy; /* writer poniżej złoży obie osie w jedno `translate` */
      }
      panelX(c, sx);
      /* spoczynek: styl zdjęty przez writer, klasa zdjęta tutaj — panel
         wraca pod normalny transition i nie trzyma nic po geście */
      if (rest) { panel.classList.remove(LEAN_CLS); return; }
      sraf = requestAnimationFrame(springStep);
    }

    /* obudzenie pętli = zdjęcie CSS-owego transition z `translate` (klasa),
       bo od tej chwili właścicielem właściwości jest integrator */
    function springWake() {
      if (sraf) return;
      panel.classList.add(LEAN_CLS);
      sraf = requestAnimationFrame(springStep);
    }

    function springTo(t, impulse) {
      if (!panel) return;
      if (!sraf && !sx && !sv && !t && !impulse) return; /* już śpi w zerze */
      stgt = t;
      sv += impulse;
      springWake();
    }

    /* ---- oś Y: dociągnięcie sheeta po swipe-down (patrz initSheetSwipe) ----
       Dlaczego integrator, a nie CSS: klasa --lean zdejmuje `transition:
       translate` (inaczej tranzycja rozmywałaby liczoną klatka po klatce oś X),
       a springStep i tak przepisuje CAŁE `translate`. CSS-owy powrót Y albo by
       nie ruszył, albo zostałby ścięty w pół przez pierwszą próbkę size-bara
       (dwa palce naraz). Jeden właściciel obu osi = zero wyścigu.
       Zwraca false, gdy nie ma czym animować (brak panelu / reduced motion /
       zero drogi) — wtedy initSheetSwipe zostaje przy ścieżce CSS. */
    function catchY(y) {
      if (!panel || !y || isReduced()) return false;
      sy = y;
      svy = 0;
      yOwn = true;
      springWake();
      return true;
    }

    /* ponowne złapanie uchwytu w trakcie dociągania: oś wraca do
       initSheetSwipe, które pisze ją wprost z palca (dwóch pisarzy = szarpanie) */
    function dropY() {
      sy = 0; svy = 0; yOwn = false;
    }

    /* ---- kick "z zewnątrz": potwierdzenie dodania do koszyka ----
       Sprężyna jest JEDNA i mieszka tutaj, w domknięciu; potwierdzenie
       (patrz ack()) potrzebuje dokładnie tego samego impulsu, którym kończy
       się dobicie kciuka do ścianki — więc zamiast drugiego integratora
       wystawiamy wąskie wejście na jego prędkość. Bez celu (stgt zostaje 0):
       panel wychyla się i sam wraca, tak jak po flicku.
       vx — impuls osi X (dodatni = w prawo, w stronę koszyka),
       vy — impuls osi Y (ujemny = w górę); oba clampowane do KICK_V, a suma
       wychylenia i tak siedzi pod bezpiecznikiem KICK_MAX w springStep.
       Zwraca false, gdy nie ma czego ruszać — wołający pomija ten krok. */
    function clampV(v) {
      if (v > KICK_V) return KICK_V;
      if (v < -KICK_V) return -KICK_V;
      return v;
    }
    function leanKick(vx, vy) {
      if (!panel || isReduced()) return false;
      /* panel już wyjeżdża (qvCloseT) albo jest PO zamknięciu, czyli
         w display:none — pętla rAF sprężyny nie ma wtedy czego animować */
      if (!c.dlg.open || c.dlg.qvCloseT) return false;
      var ix = clampV(vx || 0);
      var iy = clampV(vy || 0);
      if (!ix && !iy) return false;
      if (iy) { sy = 0; svy = iy; yOwn = true; }
      springTo(0, ix);
      springWake(); /* sam impuls Y też musi obudzić pętlę */
      return true;
    }

    var leanBase = null; /* pozycja kciuka w chwili złapania */
    var leanX = 0;       /* poprzednia próbka PALCA — do prędkości */
    var leanT = 0;
    var edge = 0;        /* -1/0/1: kciuk zaparkowany na skraju zakresu */
    var edgeKnown = false;
    var kicked = false;  /* jeden kick na dobicie */

    /* awaryjne zejście: zmiana preferencji w trakcie gestu i zamknięcie
       popupu (pointercancel nie jest gwarantowany, gdy dialog znika) */
    function leanOff() {
      if (sraf) cancelAnimationFrame(sraf);
      sraf = 0;
      sx = 0; sv = 0; stgt = 0;
      leanBase = null;
      edge = 0; edgeKnown = false; kicked = false;
      if (!panel) return;
      /* jeśli integrator trzymał oś Y, nie zostawiamy sheeta wiszącego
         w połowie drogi — reszta powrotu dojeżdża natychmiast (dokładnie to
         robi CSS pod reduced motion: .qv__panel { transition: none }) */
      if (yOwn) { yOwn = false; sy = 0; svy = 0; c.ty = 0; }
      panel.classList.remove(LEAN_CLS);
      panelX(c, 0);
    }
    if (c) {
      c.leanOff = leanOff;
      c.leanCatchY = catchY;
      c.leanDropY = dropY;
      c.leanKick = leanKick;
    }

    /* puszczenie kciuka: cel wraca na zero, sprężyna dowozi resztę */
    function leanRest() {
      leanBase = null;
      edge = 0; edgeKnown = false; kicked = false;
      if (!panel) return;
      if (isReduced()) { leanOff(); return; }
      springTo(0, 0);
    }

    /* Wołane z moveThumb, czyli z pointermove — bez własnego throttla:
       jedyne, co robi, to policzenie liczb i ustawienie celu sprężyny. */
    function respond(x, lo, hi, squash, raw, ts) {
      if (!panel) return;
      /* preferencja czytana NA ŻYWO — user może ją przełączyć w trakcie */
      if (isReduced()) { leanOff(); return; }
      /* panel w trakcie animacji wyjścia (.qv--closing): capture trzyma drag
         mimo pointer-events:none i lean/kick szarpałby znikającym oknem */
      if (c.dlg.qvCloseT) { leanOff(); return; }

      if (leanBase === null) { leanBase = x; leanX = raw; leanT = ts; }
      /* prędkość liczona z PALCA, nie z kciuka: kciuk jest clampowany do
         ścianki, więc tuż przed nią raportowałby ułamek realnego impetu
         (szybki flick z 5px zapasu wyszedłby jako spokojny dojazd) */
      var dt = ts - leanT;
      var v = dt > 0 ? (raw - leanX) / dt * 1000 : 0;
      leanX = raw;
      leanT = ts;

      /* LEAN: dławik nasycający zamiast twardego clampu — przejazd przez
         cały pasek daje ~4px, a wychylenie NIGDY nie ścina się o sufit
         (ścięcie widać jako zatrzymanie okna w połowie gestu) */
      var d = x - leanBase;
      var lean = LEAN_MAX * d / (Math.abs(d) + LEAN_SOFT);

      /* KICK: skraj dostępnego zakresu to lo/hi — kciuk tam zaparkowany
         znaczy, że live-commit siedzi już na run.a / run.b (najbliższy
         segment z definicji), więc wystarczy patrzeć na pozycję. */
      var e = x <= lo + 1 ? -1 : x >= hi - 1 ? 1 : 0;
      /* dobicie = WEJŚCIE na skraj; pierwsza próbka gestu tylko ustala stan
         wyjściowy (złapanie kciuka stojącego na skrajnym rozmiarze nie jest
         dobiciem — tam zostaje sam napór, warunek (b)) */
      var arrived = edgeKnown && e !== 0 && e !== edge;
      edgeKnown = true;
      edge = e;
      if (!e) kicked = false; /* zszedł ze ścianki — kick znów uzbrojony */

      var kick = 0;
      if (!kicked && e) {
        /* (a) flick: palec w chwili dobicia jedzie W STRONĘ tej ścianki
           (v * e > 0) i to szybciej niż próg; (b) napór: kciuk siedzi na
           ściance wgnieciony prawie do maksimum — impet bez prędkości */
        if (arrived && v * e > FLICK) kick = e;
        else if (squash >= WALL) kick = e;
        if (kick) kicked = true; /* trzymanie naporu NIE wibruje */
      }
      springTo(lean, kick * KICK_V);
    }

    function checkedIndex() {
      for (var i = 0; i < labels.length; i++) {
        var inp = labels[i].querySelector('input');
        if (inp && inp.checked) return i;
      }
      return -1;
    }

    function runAround(i) {
      if (i < 0 || !enabled[i]) i = enabled.indexOf(true);
      var a = i;
      var b = i;
      while (a > 0 && enabled[a - 1]) a--;
      while (b < labels.length - 1 && enabled[b + 1]) b++;
      return { a: a, b: b };
    }

    /* napor na wyprzedany segment: fizycznie odsuwa sie o pare px */
    var pushedSeg = null;
    function pushSeg(i, dx) {
      var seg = labels[i];
      if (pushedSeg && pushedSeg !== seg) pushedSeg.style.removeProperty('translate');
      pushedSeg = seg || null;
      if (seg) seg.style.translate = dx.toFixed(2) + 'px 0';
    }
    function clearPush() {
      if (pushedSeg) { pushedSeg.style.removeProperty('translate'); pushedSeg = null; }
    }

    function deny(i) {
      var seg = labels[i];
      if (!seg || deniedSeg === seg) return;
      deniedSeg = seg;
      seg.classList.add('size-seg--deny');
      setTimeout(function () {
        seg.classList.remove('size-seg--deny');
        deniedSeg = null;
      }, 380);
    }

    /* litera pod kciukiem: w trakcie dragu kolor podąża za kciukiem
       (paper na paper znikałby — klasa --under robi inwersję na bieżąco) */
    var underSeg = null;
    function markUnder(cx) {
      var best = null;
      var bd = Infinity;
      for (var i = 0; i < labels.length; i++) {
        var c = labels[i].offsetLeft + labels[i].offsetWidth / 2;
        var d = Math.abs(c - cx);
        if (d < bd) { bd = d; best = labels[i]; }
      }
      if (best === underSeg) return;
      if (underSeg) underSeg.classList.remove('size-seg--under');
      underSeg = best;
      if (underSeg) underSeg.classList.add('size-seg--under');
    }
    function clearUnder() {
      if (underSeg) { underSeg.classList.remove('size-seg--under'); underSeg = null; }
    }

    /* live-commit (idiom iOS): rozmiar zaznacza sie JUZ W TRAKCIE dragu,
       gdy srodek kciuka przechodzi na terytorium kolejnego segmentu —
       kto przeciaga dalej, ten chce ten rozmiar. Histereza 6px, zeby
       wybor nie migotal na samej granicy. */
    function liveCommit(cx) {
      var best = -1;
      var bd = Infinity;
      for (var i = run.a; i <= run.b; i++) {
        if (!enabled[i]) continue;
        var d = Math.abs(labels[i].offsetLeft + labels[i].offsetWidth / 2 - cx);
        if (d < bd) { bd = d; best = i; }
      }
      if (best < 0) return;
      var ci = checkedIndex();
      if (best === ci) return;
      if (ci >= 0) {
        var dc = Math.abs(labels[ci].offsetLeft + labels[ci].offsetWidth / 2 - cx);
        if (bd > dc - 6) return; /* histereza */
      }
      var inp = labels[best].querySelector('input');
      if (inp && !inp.checked) {
        inp.checked = true;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function moveThumb(e) {
      var rect = track.getBoundingClientRect();
      var tw = thumb.offsetWidth;
      var lo = labels[run.a].offsetLeft;
      var hi = labels[run.b].offsetLeft + labels[run.b].offsetWidth - tw;
      var x = e.clientX - rect.left - grabDX;
      var squash = 0; /* 0..1 — jak mocno kciuk napiera na ściankę */
      var dir = 0;
      if (x < lo) {
        if (run.a > 0) { deny(run.a - 1); pushSeg(run.a - 1, -3 * Math.min(1, (lo - x) / 56)); }
        squash = Math.min(1, (lo - x) / 56);
        dir = -1;
        x = lo - Math.min(10, (lo - x) * 0.18);
      } else if (x > hi) {
        if (run.b < labels.length - 1) { deny(run.b + 1); pushSeg(run.b + 1, 3 * Math.min(1, (x - hi) / 56)); }
        squash = Math.min(1, (x - hi) / 56);
        dir = 1;
        x = hi + Math.min(10, (x - hi) * 0.18);
      } else {
        clearPush();
      }
      /* fizyka ścianki: kciuk ściska się o krawędź (max 8%), a cały tor
         dostaje mikro-nudge do 2px w stronę naporu — czuć "dociągnięcie" */
      thumb.style.transformOrigin = dir < 0 ? 'left center' : dir > 0 ? 'right center' : '';
      thumb.style.transform =
        'translateX(' + (x - thumb.offsetLeft) + 'px)' +
        (squash ? ' scaleX(' + (1 - 0.08 * squash).toFixed(3) + ')' : '');
      track.style.transform = squash ? 'translateX(' + (dir * 2 * squash).toFixed(2) + 'px)' : '';
      markUnder(x + tw / 2);
      liveCommit(x + tw / 2);
      /* na końcu, na JUŻ policzonym x: okno odpowiada na to, co realnie
         zrobił kciuk (po clampie i rubber-bandzie), a nie na surowy palec */
      respond(x, lo, hi, squash, e.clientX, e.timeStamp);
    }

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      armed = true;
      dragging = false;
      startX = e.clientX;
      run = runAround(checkedIndex());
      /* Pusty stan (mobile — brak pre-zaznaczenia): przytrzymanie palca od
         razu wyciąga kciuk pod palec — wybór przez przesunięcie, bez
         konieczności celowania tapnięciem. */
      if (checkedIndex() === -1) {
        dragging = true;
        track.setPointerCapture(e.pointerId);
        bar.classList.add('size-bar--dragging', 'size-bar--picking');
        grabDX = thumb.offsetWidth / 2;
        moveThumb(e);
      }
    });

    track.addEventListener('pointermove', function (e) {
      if (!armed) return;
      if (!dragging) {
        if (Math.abs(e.clientX - startX) < 5) return;
        dragging = true;
        track.setPointerCapture(e.pointerId);
        bar.classList.add('size-bar--dragging');
        /* offset chwytu od pozycji kciuka w chwili zlapania — kciuk NIE
           skacze srodkiem pod palec (bug: przeskok w prawo, gdy kciuk
           stoi skrajnie przy sold-out i lapie sie go za krawedz) */
        var sRect = track.getBoundingClientRect();
        var ci = checkedIndex();
        var thumbLeft = ci >= 0 ? labels[ci].offsetLeft : startX - sRect.left - thumb.offsetWidth / 2;
        grabDX = startX - sRect.left - thumbLeft;
      }
      moveThumb(e);
    });

    function release(e, commit) {
      armed = false;
      if (!dragging) return; /* czysty klik — natywny label robi swoje */
      dragging = false;
      bar.classList.remove('size-bar--dragging', 'size-bar--picking');
      thumb.style.transform = '';
      thumb.style.transformOrigin = '';
      track.style.transform = ''; /* springback z transition w CSS */
      clearPush();
      clearUnder();
      leanRest();
      if (!commit) return;
      var rect = track.getBoundingClientRect();
      var x = e.clientX - rect.left - grabDX + thumb.offsetWidth / 2;
      var best = null;
      var bestDist = Infinity;
      for (var i = run.a; i <= run.b; i++) {
        if (!enabled[i]) continue;
        var center = labels[i].offsetLeft + labels[i].offsetWidth / 2;
        var dist = Math.abs(center - x);
        if (dist < bestDist) { bestDist = dist; best = labels[i].querySelector('input'); }
      }
      if (best && !best.checked) {
        best.checked = true;
        best.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    track.addEventListener('pointerup', function (e) { release(e, true); });
    track.addEventListener('pointercancel', function (e) { release(e, false); });
  }

  /* ---------- slide to add (port z PDP, per popup) ---------- */
  function initSlide(c) {
    if (!c.slide || !c.thumb || !c.form || !window.PointerEvent) return;
    var wrap = c.slide;
    var thumb = c.thumb;
    var armed = false;
    var dragging = false;
    var suppressClick = false;
    var startX = 0;
    var maxX = 0;
    var lastX = 0;

    function range() {
      return wrap.clientWidth - thumb.offsetWidth - 8; /* 2 × padding toru */
    }

    thumb.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (thumb.disabled || wrap.classList.contains('slide-buy--done')) return;
      armed = true;
      dragging = false;
      startX = e.clientX;
      maxX = range();
    });

    thumb.addEventListener('pointermove', function (e) {
      if (!armed) return;
      if (!dragging) {
        if (Math.abs(e.clientX - startX) < 5) return;
        dragging = true;
        thumb.setPointerCapture(e.pointerId);
        wrap.classList.add('slide-buy--dragging');
      }
      lastX = Math.max(0, Math.min(maxX, e.clientX - startX));
      thumb.style.transform = 'translateX(' + lastX + 'px)';
      wrap.style.setProperty('--slide-p', (lastX / maxX).toFixed(3));
    });

    function release(commit) {
      armed = false;
      if (!dragging) return;
      dragging = false;
      suppressClick = true; /* click po dragu nie może submitować sam z siebie */
      wrap.classList.remove('slide-buy--dragging');
      if (commit && lastX >= maxX * 0.85) {
        wrap.classList.add('slide-buy--done');
        thumb.style.transform = 'translateX(' + maxX + 'px)';
        if (c.form.requestSubmit) c.form.requestSubmit(thumb);
        else c.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } else {
        thumb.style.transform = '';
        wrap.style.setProperty('--slide-p', '0');
      }
    }

    thumb.addEventListener('pointerup', function () { release(true); });
    thumb.addEventListener('pointercancel', function () { release(false); });
    thumb.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); suppressClick = false; }
    });
  }

  /* ---------- bottom sheet: swipe w dół po uchwycie = zamknij ---------- */
  function initSheetSwipe(c) {
    var grip = c.dlg.querySelector('[data-qv-grip]');
    if (!grip || !c.panel || !window.PointerEvent) return;
    var dragging = false;
    var startY = 0;
    var dy = 0;

    grip.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-qv-close]')) return;
      if (!isMobile()) return;
      dragging = true;
      dy = 0;
      startY = e.clientY;
      grip.setPointerCapture(e.pointerId);
      /* uchwyt złapany w trakcie dociągania: odbieramy oś Y sprężynie
         size-bara, zanim zaczniemy pisać ją z palca (patrz end() niżej) */
      if (c.leanDropY) c.leanDropY();
      c.panel.style.transition = 'none';
    });

    grip.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dy = Math.max(0, e.clientY - startY);
      /* przez wspólny writer: oś X panelu może w tym momencie nieść lean
         size-bara (dwa palce) — pisanie tu gołego "0 Ypx" ścięłoby ją */
      panelY(c, dy);
    });

    function end() {
      if (!dragging) return;
      dragging = false;
      c.panel.style.removeProperty('transition');
      if (dy > 90) {
        /* translate ZOSTAJE: animacja wyjścia dokańcza zjazd z miejsca, w które
           user doprowadził sheet (strzepnięcie), a nie z pozycji spoczynkowej.
           Sprząta handler 'close'. */
        dismiss(c.dlg);
        return;
      }
      /* Sprężysty powrót. Właścicielem `translate` jest sprężyna size-bara,
         jeśli popup ją ma: jej klasa --lean zdejmuje `transition: translate`
         i przepisuje styl co klatkę, więc CSS-owa tranzycja albo by tu nie
         ruszyła, albo zostałaby ścięta w pół, gdy user tknie rozmiar w trakcie
         powrotu. Fallback (produkt bez wyboru rozmiaru, reduced motion) —
         ścieżka CSS, bez zmian. */
      if (c.leanCatchY && c.leanCatchY(dy)) return;
      panelY(c, 0); /* sprężysty powrót (transition na translate w CSS) */
    }
    grip.addEventListener('pointerup', end);
    grip.addEventListener('pointercancel', end);
  }

  /* ---------- lightbox ---------- */
  function initLightbox(c) {
    var lb = c.lb;
    var zoom = c.dlg.querySelector('[data-qv-zoom]');
    if (!lb) return;
    var imgs = [].slice.call(lb.querySelectorAll('[data-lb-img]'));
    if (!imgs.length) {
      /* produkt bez zdjęć — nie zostawiamy martwej afordancji */
      if (zoom) { zoom.disabled = true; zoom.classList.add('qv__media--flat'); }
      return;
    }
    var counter = lb.querySelector('[data-lb-count]');
    var stage = lb.querySelector('[data-lb-stage]');
    var i = 0;

    function show(n) {
      i = (n + imgs.length) % imgs.length;
      for (var k = 0; k < imgs.length; k++) imgs[k].hidden = k !== i;
      /* siatka bezpieczeństwa (np. Save-Data pominął rozgrzewkę):
         bieżące + sąsiad, żeby strzałka nie trafiała w zimny obraz */
      imgs[i].loading = 'eager';
      revealWhenLoaded(imgs[i]);
      if (imgs.length > 1) imgs[(i + 1) % imgs.length].loading = 'eager';
      if (counter) counter.textContent = i + 1 + ' / ' + imgs.length;
    }

    var prev = lb.querySelector('[data-lb-prev]');
    var next = lb.querySelector('[data-lb-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });

    lb.addEventListener('keydown', function (e) {
      if (imgs.length < 2) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
    });

    var closeBtn = lb.querySelector('[data-lb-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { lb.close(); });

    /* Gesty w kadrze: TAP zamyka, poziomy swipe >44px przełącza (tylko >1
       zdjęcie), pionowy ruch nie robi nic. Fullscreen podgląd służy do
       oglądania, więc pinch-to-zoom należy do przeglądarki (patrz touch-action)
       i NIE MOŻE zamykać lightboxa: trzymamy listę palców w kadrze i każdy
       gest, w którym pojawił się drugi, jest dla nas nieistniejący. */
    if (stage && window.PointerEvent) {
      var downX = 0;
      var downY = 0;
      var pts = []; /* id-ki palców trzymanych w kadrze */
      var multi = false;

      function drop(id) {
        var k = pts.indexOf(id);
        if (k > -1) pts.splice(k, 1);
        if (!pts.length) multi = false;
      }

      stage.addEventListener('pointerdown', function (e) {
        pts.push(e.pointerId);
        if (pts.length > 1) { multi = true; return; }
        downX = e.clientX;
        downY = e.clientY;
      });

      /* Palec puszczony poza kadrem (X, strzałki) albo gest przerwany przez
         przeglądarkę (właśnie tak kończy się pinch) NIE MOŻE zostawić id na
         liście — inaczej każdy następny tap wyglądałby jak drugi palec i
         lightbox przestałby się zamykać. Sprzątamy więc na całym dialogu,
         który w trybie modalnym i tak wypełnia viewport. */
      lb.addEventListener('pointerup', function (e) { drop(e.pointerId); });
      lb.addEventListener('pointercancel', function (e) { drop(e.pointerId); });

      stage.addEventListener('pointerup', function (e) {
        var single = pts.length === 1 && pts[0] === e.pointerId && !multi && e.isPrimary;
        drop(e.pointerId);
        if (!single) return;
        var dx = e.clientX - downX;
        var dy = e.clientY - downY;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) {
          if (imgs.length > 1) show(dx < 0 ? i + 1 : i - 1);
          return;
        }
        /* tylko czysty tap — niedokładne muśnięcie nie gasi zoomu, który user
           dopiero co otworzył */
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) lb.close();
      });
    }

    if (zoom) {
      zoom.addEventListener('click', function () {
        show(0);
        lb.showModal();
      });
    }
  }

  /* ---------- wiring per popup ---------- */
  dialogs.forEach(function (dlg) {
    var c = ctxOf(dlg);

    /* X */
    var closeBtns = dlg.querySelectorAll('[data-qv-close]');
    for (var i = 0; i < closeBtns.length; i++) {
      closeBtns[i].addEventListener('click', function () { dismiss(dlg); });
    }

    /* VIEW INFO <-> BACK (drugi widok kolumny: opis + spec) */
    if (c.infoOpen) {
      c.infoOpen.addEventListener('click', function () { setInfoView(c, true); });
    }
    if (c.infoClose) {
      c.infoClose.addEventListener('click', function () { setInfoView(c, false); });
    }

    /* klik w tło: <dialog> wypełnia viewport, panel jest w środku, więc
       "target === dialog" znaczy dokładnie "poza panelem" */
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dismiss(dlg);
    });

    /* Esc — natywny cancel przekierowany na naszą ścieżkę (żeby zwinąć historię).
       Guard e.target: lightbox jest ZAGNIEŻDŻONYM dialogiem, a implementacje
       różnią się co do bąbelkowania cancel/close — Esc w lightboxie nie może
       zamykać popupu pod nim. */
    dlg.addEventListener('cancel', function (e) {
      if (e.target !== dlg) return;
      e.preventDefault();
      dismiss(dlg);
    });

    /* jedyne miejsce sprzątania — łapie też close() z dowolnego źródła */
    dlg.addEventListener('close', function (e) {
      if (e.target !== dlg) return; /* patrz guard w 'cancel' */
      if (current === dlg) { current = null; unlockScroll(); }
      resetSlide(c);
      /* potwierdzenie na CTA żyje DO zamknięcia (ink wipe jest committed),
         więc zdejmujemy je dopiero tutaj — po wyjeździe panelu */
      resetAck(c);
      resetPanelTranslate(c);
      if (c.panel) c.panel.style.removeProperty('transition');
    });

    /* rozmiar wybrany → suwak wjeżdża i staje się aktywny */
    if (c.bar) {
      c.bar.addEventListener('change', function () { armSlide(c, true); });
      initSizeDrag(c.bar, c);
    }

    /* tap w suwak przed wyborem rozmiaru (mobile): zero głuchego gestu —
       pasek rozmiarów strzepuje i hint pulsuje, czyli user widzi CO zrobić */
    if (c.foot && c.bar) {
      c.foot.addEventListener('click', function () {
        if (c.foot.classList.contains('qv__foot--active')) return;
        c.bar.classList.remove('size-bar--nudge');
        void c.bar.offsetWidth; /* restart animacji */
        c.bar.classList.add('size-bar--nudge');
        setTimeout(function () { c.bar.classList.remove('size-bar--nudge'); }, 900);
      });
    }

    initSlide(c);
    initSheetSwipe(c);
    initLightbox(c);

    /* AJAX add to cart; bez fetch zostaje natywny POST → /cart */
    if (c.form && window.fetch) {
      c.form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(c);
      });
    }
  });

  /* ---------- przechwycenie kliku w kartę ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('[data-quick-view]');
    if (!card) return;
    var dlg = document.getElementById(card.getAttribute('data-quick-view'));
    if (!dlg) return; /* np. karta z wyników szukania bez popupu */
    e.preventDefault();
    open(dlg, card.getAttribute('href'));
  });

  /* dopiero teraz karta jest przyciskiem otwierającym dialog — bez JS
     pozostaje zwykłym linkiem na PDP i taka musi być jej semantyka */
  document.querySelectorAll('[data-quick-view]').forEach(function (card) {
    var dlg = document.getElementById(card.getAttribute('data-quick-view'));
    if (!dlg) return;
    card.setAttribute('aria-haspopup', 'dialog');

    /* preload z intencji: hover/focus/dotknięcie karty grzeje hero popupu
       (na Retinie popup bierze większy plik niż karta — bez tego otwarcie
       czekałoby na sieć). Jeden strzał per karta. */
    var warmHero = function () {
      var shot = dlg.querySelector('.qv__shot');
      if (shot) shot.loading = 'eager';
      card.removeEventListener('pointerenter', warmHero);
      card.removeEventListener('focus', warmHero);
      card.removeEventListener('touchstart', warmHero);
    };
    card.addEventListener('pointerenter', warmHero);
    card.addEventListener('focus', warmHero);
    card.addEventListener('touchstart', warmHero, { passive: true });
  });
})();
